import React from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";

const TopLateOffenders = ({ topoffenders }) => {
  return (
    <div className="px-4 py-2 rounded-[12.75px] h-[100%] border border-black/10 bg-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10),0px_1px_2px_-1px_rgba(0,0,0,0.10)] w-full mx-auto">
      {/* Header */}
      <div className="flex items-center mb-1">
        <AccessTimeIcon className="text-[#FD9A00] mr-2" style={{ fontSize: "23px" }} />
        <div className="text-lg font-semibold">Top Late Offenders</div>
      </div>

      {/* Subheading */}
      <div className="text-sm text-start text-[#717182] mb-3">
        Employees with the most late arrivals
      </div>

      {/* Table */}
      <div className="text-sm w-full mt-8">
        {/* Table Header */}
        <div className="flex font-semibold pb-2 border-b gap-[2px] border-black/10">
          <div className="w-1/2 text-start text-xs text-[#0A0A0A] font-semibold">Employee</div>
          <div className="w-1/4 text-start text-xs text-[#0A0A0A] font-semibold">Late Count</div>
          <div className="w-1/4 text-start text-xs text-[#0A0A0A] font-semibold">Avg. Late</div>
        </div>

        {/* Scrollable Rows or No Data */}
        <div className="max-h-[142vh] overflow-y-auto pr-1 custom-scrollbar">
          {topoffenders && topoffenders.length > 0 ? (
            topoffenders.map((emp, index) => (
              <div key={index} className="flex py-2 border-b border-black/10">
                {/* Employee Name and Title */}
                <div className="w-1/2 flex items-center text-start">
                  <div className="inline-flex items-center gap-2 py-1">
                    <div className="rounded-full shadow-md p-1">
                      <PermIdentityIcon className="text-gray-500" style={{ fontSize: "18px" }} />
                    </div>
                    <div>
                      <div className="font-semibold text-xs">{emp.emp_name}</div>
                      <div className="text-[10px] text-gray-500">{emp?.department}</div>
                    </div>
                  </div>
                </div>

                {/* Late Count */}
                <div className="w-1/4 flex items-center text-start">
                  <div className="text-[#BB4D00] bg-[#FFFBEB] px-2 py-1 text-xs rounded-full inline-block">
                    {emp?.late_count}
                  </div>
                </div>

                {/* Avg. Late */}
                <div className="w-1/4 flex items-center text-xs text-end font-semibold">
                  <div>{emp?.avg_late}</div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-xs text-gray-500 py-4">
              No data available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopLateOffenders;
